import { useCountUp } from '../hooks/useCountUp';
import { STATS } from '../lib/site';

const Stat = ({ value, suffix, label }: { value: number; suffix: string; label: string }) => {
  const { ref, value: v } = useCountUp(value);
  return (
    <div ref={ref} className="text-center md:text-left">
      <p className="stat-number text-[clamp(2.5rem,5vw,3.75rem)] text-paper">
        {v.toLocaleString('es-ES')}
        <span className="text-clay-light">{suffix}</span>
      </p>
      <p className="mt-2 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-paper/55">{label}</p>
    </div>
  );
};

/**
 * Banda de resultados — números reales de la empresa con contadores animados.
 */
const StatsBand = () => {
  return (
    <section className="bg-ink text-paper border-y border-line-dark" aria-label="HGO Servicios en cifras">
      <div className="max-w-[1400px] mx-auto px-6 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {STATS.map((s) => (
            <Stat key={s.label} {...s} />
          ))}
        </div>
        <p className="mt-12 pt-6 border-t border-paper/10 text-paper/50 text-sm max-w-2xl leading-relaxed">
          Cifras de <strong className="text-paper/80 font-semibold">obra real entregada</strong> en Málaga capital y la
          Costa del Sol: viviendas, locales comerciales y comunidades de propietarios.
        </p>
      </div>
    </section>
  );
};

export default StatsBand;
